import { render, staticRenderFns } from "./zhidu.vue?vue&type=template&id=072c2b06&scoped=true&"
import script from "./zhidu.vue?vue&type=script&lang=js&"
export * from "./zhidu.vue?vue&type=script&lang=js&"
import style0 from "./zhidu.vue?vue&type=style&index=0&id=072c2b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c2b06",
  null
  
)

export default component.exports